import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cancellation-reason-form" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "applicant-options-container" }
const _hoisted_4 = { class: "applicant-options" }
const _hoisted_5 = { class: "xradio label-text" }
const _hoisted_6 = { class: "radio-text" }
const _hoisted_7 = ["value", "checked", "onChange"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "sc-form-field" }
const _hoisted_10 = ["disabled", "title"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "row footer xdropdown-buttons sc-dropdown-buttons" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

import { ref, computed, toRef, toRefs, onMounted, watch } from "vue";
import { Field, ErrorMessage, useForm } from "vee-validate";
import * as yup from "yup";
import { Type, LOSType } from "@/types/types";
import { useTypeStore } from "@/store/store/typeStore";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { ApplicantVM } from "@/types/applicant";
import { ApplicationStatusIds } from "@/types/application";


export default /*@__PURE__*/_defineComponent({
  __name: 'CancellationReasonForm',
  props: {
    statusId: {},
    initialStatusId: {}
  },
  emits: ["cancel", "submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const applicationStoreV2 = useApplicationStore();
const typeStore = useTypeStore();

const props = __props;

const { statusId } = toRefs(props);

const emit = __emit;

const validationSchema = computed(() => {
  return yup.object().shape({
    selectedApplicantId: yup.number().required("An applicant is required"),
    selectedReasonId: yup.number().required("A reason is required"),
  });
});

const { values, validate, errors, setFieldValue, setFieldTouched } = useForm({
  validationSchema: validationSchema.value,
});

const selectedApplicantRefs = ref<Array<InstanceType<typeof Field>> | null>(
  null
);

const showForm = ref<boolean>(false);

const selectedReasonId = toRef(values, "selectedReasonId");

const selectedApplicantId = toRef(values, "selectedApplicantId");

const savingChanges = ref<boolean>(false);

// Computed Values
const isFormValid = computed<boolean>(() => {
  return (
    selectedReasonId.value !== undefined &&
    selectedReasonId.value !== null &&
    selectedApplicantId.value !== null &&
    selectedApplicantId.value !== undefined
  );
});

const applicants = computed<Array<ApplicantVM>>(
  () => applicationStoreV2.Applicants
);

const selectedReason = computed<LOSType | undefined>(() => {
  return cancellationReasons.value.find(
    (r: LOSType) => r.id === Number(values.selectedReasonId)
  );
});

const selectedApplicant = computed<ApplicantVM | undefined>(() => {
  return applicants.value.find(
    (r: ApplicantVM) => r.id === Number(values.selectedApplicantId)
  );
});

const cancellationReasons = computed<Array<LOSType>>(() =>
  typeStore.getTypes(Type.ApplicationStatusReasons)
);

const comment = computed<string>(
  () =>
    `Application status updated to Cancelled due to ${selectedReason.value?.description} per ${selectedApplicant.value?.fullName}'s request.`
);

function resetForm() {
  setFieldValue("selectedApplicantId", null);
  setFieldValue("selectedReasonId", null);

  setFieldTouched("selectedApplicantId", false);
  setFieldTouched("selectedReasonId", false);
}

function cancel() {
  resetForm();
  emit("cancel");
}

function toggleForm(flag: boolean) {
  showForm.value = flag;
}

function setSavingChanges(flag: boolean) {
  savingChanges.value = flag;
}

function submit() {
  savingChanges.value = true;
  emit("submit");
}

function handleChange(applicantId: number, event: any) {
  setFieldValue("selectedApplicantId", Number(applicantId));
}

async function initialize() {
  await typeStore.getType(Type.ApplicationStatusReasons);
  if (applicants.value.length === 1) {
    setFieldValue("selectedApplicantId", applicants.value[0].id);
  }
}

onMounted(async () => {
  await initialize();
});

watch(statusId, (newValue: any) => {
  if (newValue === ApplicationStatusIds.CANCELLED && props.initialStatusId !== ApplicationStatusIds.DECLINED) {
    initialize();
  } else {
    resetForm();
    showForm.value = false;
  }
});

__expose({
  selectedReasonId,
  selectedApplicantId,
  selectedReason,
  comment,
  validate,
  setSavingChanges,
  toggleForm,
  resetForm,
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sc-label" }, [
        _createTextVNode(" Cancellation Requested For?"),
        _createElementVNode("span", { class: "required" }, "*")
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sc-help" }, " Select the applicant the cancellation reason applies to. ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applicants.value, (applicant) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "applicant-option",
              key: applicant.id
            }, [
              _createVNode(_unref(Field), {
                ref_for: true,
                ref_key: "selectedApplicantRefs",
                ref: selectedApplicantRefs,
                name: "selectedApplicantId",
                disabled: savingChanges.value,
                uncheckedValue: null,
                checkedValue: Number(applicant.id),
                checked: Number(selectedApplicantId.value) === Number(applicant.id),
                modelValue: selectedApplicantId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedApplicantId).value = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("label", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(applicant.fullName) + " - " + _toDisplayString(applicant.applicantTypeName), 1),
                    _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                      type: "radio",
                      value: applicant.id,
                      checked: 
                    Number(selectedApplicantId.value) === Number(applicant.id)
                  ,
                      onChange: ($event: any) => (handleChange(Number(applicant.id), $event))
                    }), null, 16, _hoisted_7),
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1))
                  ])
                ]),
                _: 2
              }, 1032, ["disabled", "checkedValue", "checked", "modelValue"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "sc-label" }, [
        _createTextVNode(" Cancellation Reason"),
        _createElementVNode("span", { class: "required" }, "*")
      ], -1)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "sc-help" }, " Please select a reason for the cancellation from the list below. ", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sc-label" }, "Cancellation Reason List", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(Field), { name: "selectedReasonId" }, {
          default: _withCtx(({ field }) => [
            _createElementVNode("select", _mergeProps(field, {
              disabled: savingChanges.value,
              title: selectedReason.value ? selectedReason.value.description : undefined
            }), [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cancellationReasons.value, (reason) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: reason.id,
                  value: reason.id
                }, _toDisplayString(reason.description), 9, _hoisted_11))
              }), 128))
            ], 16, _hoisted_10)
          ]),
          _: 1
        }),
        _createVNode(_unref(ErrorMessage), {
          class: "error-message",
          name: "selectedReasonId"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _withDirectives(_createElementVNode("button", {
        class: "invert-color",
        onClick: _withModifiers(cancel, ["prevent"]),
        disabled: savingChanges.value
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("span", { class: "button-text" }, "Cancel", -1)
      ]))], 8, _hoisted_13), [
        [_vShow, !savingChanges.value]
      ]),
      _createElementVNode("button", {
        onClick: _withModifiers(submit, ["prevent"]),
        class: _normalizeClass([{ loading: savingChanges.value }]),
        disabled: !isFormValid.value || savingChanges.value
      }, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("span", { class: "button-text" }, "Save Changes", -1)
      ]))], 10, _hoisted_14)
    ])
  ], 512)), [
    [_vShow, showForm.value]
  ])
}
}

})